import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api/client";
import { renderMarkdownSafe } from "../utils/markdown";

type NewsDetail = {
  id: number;
  title: string;
  content_md: string;
  content_html?: string;
  created_at: string;
};

export const NewsDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [news, setNews] = useState<NewsDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/news/detail", { params: { id } });
        setNews(res.data);
      } catch (err: any) {
        setError(err?.response?.data?.error || "Fehler beim Laden der News");
      }
    };
    load();
  }, [id]);

  if (error) {
    return <div style={{ padding: "1rem" }}>Fehler: {error}</div>;
  }

  if (!news) {
    return <div style={{ padding: "1rem" }}>Lade...</div>;
  }

  const html = news.content_html ?? renderMarkdownSafe(news.content_md);

  return (
    <article className="news-detail" style={{ padding: "1rem" }}>
      <h1>{news.title}</h1>
      <p className="news-meta">{new Date(news.created_at).toLocaleString("de-DE")}</p>
      <div
        className="news-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </article>
  );
};
